/* eslint-disable indent */
import produce, { Draft } from 'immer';
import {
    GET_TAG,
    SET_TAG,
    UPDATE_TAG,
    GET_SINGLE_USE_TAGS,
    SET_INVALID_TAGS,
    CLEAR_ERRORS,
} from '../../constants/actionTypes/personalization';
import { IPersonalizationSingleUseTag, IPersonalizationTagDefault } from '../../types/personalization';

interface State {
    tag: {
        tags: {
            default: IPersonalizationTagDefault | {};
            singleUse: IPersonalizationSingleUseTag | {};
        };
        invalidTags: string[];
        isGetTagLoading: boolean;
        isSetTagLoading: boolean;
        isGetSingleUseTagsLoading: boolean;
        getTagError: null | string;
        setTagError: null | string;
        getSingleUseTagsError: null | string;
    };
}

export const initialState: State = {
    tag: {
        tags: {
            default: {},
            singleUse: {},
        },
        invalidTags: [],
        isGetTagLoading: false,
        isSetTagLoading: false,
        isGetSingleUseTagsLoading: false,
        getTagError: null,
        setTagError: null,
        getSingleUseTagsError: null,
    },
};

const personalization = produce((draft: Draft<State>, action) => {
    const { type, payload }: { type: string; payload: any } = action;
    switch (type) {
        case GET_TAG.BEGIN:
            draft.tag.isGetTagLoading = true;
            draft.tag.getTagError = null;
            break;
        case GET_TAG.SUCCESS:
            draft.tag.tags.default = payload.defaultTags;
            draft.tag.getTagError = null;
            draft.tag.isGetTagLoading = false;
            break;
        case GET_TAG.ERROR:
            draft.tag.getTagError = payload.error;
            draft.tag.isGetTagLoading = false;
            break;
        case SET_TAG.BEGIN:
            draft.tag.isSetTagLoading = true;
            draft.tag.setTagError = null;
            break;
        case SET_TAG.SUCCESS:
            draft.tag.setTagError = null;
            draft.tag.isSetTagLoading = false;
            break;
        case SET_TAG.ERROR:
            draft.tag.setTagError = payload.error;
            draft.tag.isSetTagLoading = false;
            break;
        case UPDATE_TAG:
            // eslint-disable-next-line no-case-declarations
            const { name, fallback, sample, isEnabled } = payload;

            // hardcoded defaultTags for v1
            // @ts-ignore
            draft.tag.tags.default[name] = {
                fallback,
                sample,
                isEnabled,
            };

            break;
        case GET_SINGLE_USE_TAGS.BEGIN:
            draft.tag.isGetSingleUseTagsLoading = true;
            draft.tag.getSingleUseTagsError = null;
            break;
        case GET_SINGLE_USE_TAGS.SUCCESS:
            draft.tag.tags.singleUse = payload;
            draft.tag.getSingleUseTagsError = null;
            draft.tag.isGetSingleUseTagsLoading = false;
            break;
        case GET_SINGLE_USE_TAGS.ERROR:
            draft.tag.getSingleUseTagsError = payload.error;
            draft.tag.isGetSingleUseTagsLoading = false;
            break;
        case SET_INVALID_TAGS:
            draft.tag.invalidTags = payload;
            break;
        case CLEAR_ERRORS:
            draft.tag.getTagError = null;
            draft.tag.setTagError = null;
            draft.tag.getSingleUseTagsError = null;
            break;
        default:
    }
}, initialState);

export default personalization;
